<template>
  <nav class="flex-between navbar" :class="{ scrolled: isScrolled }">
    <div class="nav-container flex-between">
      <div class="nav-left">
        <ul class="menu-wrap flex-between">
          <li
            v-for="(item, index) in navItems"
            :key="index"
            class="menu-item"
            :class="{ 'menu-item-img': item.type == 2 }"
          >
            <template v-if="item.type == 2">
              <div class="tab_logo" @click="goHome"></div>
            </template>
            <template v-else>
              <div
                class="menu-item-text flex-between"
                @mouseenter="handleMouseEnter(item)"
                @click="handleMenuItem(item)"
              >
                {{ $t(`nav.${item.key}`) }}
              </div>
            </template>
          </li>
        </ul>
      </div>
      <div class="lang-join-wrap flex-rowr">
        <div class="lang flex-rowc">
          VESCOR Global <i class="iconfont icon-diqiu"></i>
        </div>
        <!-- 使用可复用下拉筛选组件 -->
        <CustomDropdown :options="countries" @select="handleDropdown">
          {{ COUNTRY.text }}
        </CustomDropdown>
        <el-dropdown
          class="country-select"
          @command="handleDropdown"
          v-if="false"
        >
          <div class="selected-country el-dropdown-link flex-between">
            <div class="content flex-rowl">
              <!-- <span class="flag"
              ><img style="width: 26px; height: 17px" :src="COUNTRY.icon"
            /></span> -->
              <span>{{ COUNTRY.countryname }}</span>
            </div>
            <div class="arr">
              <i class="iconfont icon-select-down"></i>
            </div>
          </div>
          <el-dropdown-menu class="country-list" @command="handleDropdown">
            <el-dropdown-item
              class="country-item flex-rowl"
              v-for="(country, index) in countries"
              :key="index"
              :command="country"
            >
              <!-- <img style="width: 26px; height: 17px" :src="country.icon" /> -->
              <p>
                {{ country.countryname }}
              </p></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 使用 <transition> 组件添加过渡动画 -->
    <transition name="slide" v-if="isShowMenu">
      <div class="menu-child-toggle" @mouseleave="handleMouseLeave">
        <div class="menu-child-toggle-container flex-between">
          <div class="menu-child-main flex-rowl">
            <p
              class="menu-child-text"
              v-if="activeNavItem.allText"
              @click="handleMenu(activeNavItem)"
            >
              <!-- {{ activeNavItem.allText }}= -->
              {{ $t(`nav.pMenu.${activeNavItem.allTextKey}`) }}
            </p>
            <div
              class="menu-child-list"
              :class="
                activeNavItem.layout === 'horizontal'
                  ? 'flex-colc'
                  : 'flex-between'
              "
            >
              <div
                v-for="(itemChild, indexChild) in activeNavItem.classify"
                :key="indexChild"
                class="menu-child-item"
                :class="
                  activeNavItem.layout === 'horizontal' ? 'flex-rowl' : ''
                "
              >
                <p
                  class="f-source-han-serif-cn-M"
                  @click="handleMenu(itemChild)"
                >
                  {{
                    activeNavItem.layout === "horizontal"
                      ? $t(`nav.bMenu.${itemChild.key}`)
                      : $t(`nav.pMenu.${itemChild.key}`)
                  }}
                </p>
                <ul>
                  <li
                    v-for="(itemChildItem, indexChildItem) in itemChild.items"
                    :key="indexChildItem"
                    @click="handleMenuItem(itemChildItem)"
                    class="f-source-han-sans-cn-L"
                  >
                    {{
                      activeNavItem.layout === "horizontal"
                        ? $t(`nav.bMenu.${itemChildItem.key}`)
                        : $t(`nav.pMenu.${itemChildItem.key}`)
                    }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="img"><img :src="activeNavItem.img" alt="" /></div>
        </div>
      </div>
    </transition>
  </nav>
</template>
  
  <script>
import CustomDropdown from "./CustomDropdown.vue";
import { mapState } from "vuex";
export default {
  name: "Navbar",
  components: { CustomDropdown },
  data() {
    return {
      navItems: [
        {
          id: 1,
          key: "home",
          text: "首頁",
          link: "/Home",
          allText: "",
        },
        {
          id: 2,
          text: "品牌",
          key: "brand",
          // 分类
          // 子元素在页面中布局（横向/纵向）
          layout: "horizontal", // 可以是 'horizontal' 或 'vertical'
          classify: [
            {
              key: "understand",
              text: "了解VESCOR",
              link: "/BrandPage",
              items: [
                {
                  key: "desc1",
                  text: "在阿爾卑斯山脈終年積雪的褶皺間，瑞士Cellcare實驗室的科學家們以冰川融水為靈感，解碼時間對肌膚的低語。2017年誕生的VESCOR，不僅是高端護膚品牌，更是跨越時空的美學契約。",
                  link: "/BrandPage",
                },
              ],
            },
            {
              key: "tech",
              text: "技術與專業",
              link: "/TechPage",
              items: [
                {
                  key: "desc2",
                  text: "Cellcare瑞士實驗室，世界三大純生態原料研究生產工廠之-CRB， 打造了革命性的護膚科技。",
                  link: "/TechPage",
                },
              ],
            },
          ],
          img: require("@/assets/images/menu_product.png"),
        },
        {
          id: 3,
          key: "product",
          text: "產品",
          allText: "所有產品",
          allTextKey: "allProducts",
          // 分类
          // 子元素在页面中布局（横向/纵向）
          layout: "vertical", // 可以是 'horizontal' 或 'vertical'
          link: "/ProductCatalog",
          catalogType: 1,
          classify: [
            {
              text: "面膜",
              key: "mask",
              link: "/ProductCatalog",
              catalogType: 2,
              items: [
                {
                  text: "膠原蛋白蜜肌面膜",
                  key: "mask1",
                  link: "/ProductDetailPage/detail1",
                },
                {
                  text: "黑鑽至臻炭煥顏面膜",
                  key: "mask2",
                  link: "/ProductDetailPage/detail2",
                },
              ],
            },
            {
              text: "彈力賦活系列",
              key: "elastic",
              link: "/ProductCatalog",
              catalogType: 3,
              items: [
                {
                  text: "彈力賦活精華水",
                  key: "elastic1",
                  link: "/ProductDetailPage/detail3",
                },
                {
                  text: "彈力賦活抗皺精華液",
                  key: "elastic2",
                  link: "/ProductDetailPage/detail4",
                },
                {
                  text: "彈力賦活抗皺精華霜",
                  key: "elastic3",
                  link: "/ProductDetailPage/detail5",
                },
              ],
            },
            {
              text: "賦顏菁萃系列",
              key: "essence",
              link: "/ProductCatalog",
              catalogType: 4,
              items: [
                {
                  text: "賦顏菁萃精華油",
                  key: "essence1",
                  link: "/ProductDetailPage/detail6",
                },
                {
                  text: "柔光水潤粉底液",
                  key: "essence2",
                  link: "/ProductDetailPage/detail7",
                },
              ],
            },
          ],
          img: require("@/assets/images/menu_product.png"),
        },
        {
          id: 4,
          key: "exclusive",
          text: "尊享·尊寵",
          link: "/ProductPage",
          layout: "horizontal", // 可以是 'horizontal' 或 'vertical'
        },
        {
          type: 2, // 图片类型
        },

        {
          id: 5,
          key: "cooperation",
          text: "合作",
          link: "/CooperationPage",
          layout: "horizontal", // 可以是 'horizontal' 或 'vertical'
        },
        {
          id: 6,
          key: "contact",
          text: "聯絡我們",
          link: "/ContactPage",
          layout: "horizontal", // 可以是 'horizontal' 或 'vertical'
        },
      ],
      isScrolled: false,
      isShowMenu: false, // 显示子导航时
      // 导航子元素
      activeNavItem:'',

      countries: [
        // {
        //   id: 1,
        //   countryname: "Schweiz",
        //   icon: "https://upload.vwingist.com/melscn/0image/2024/12/5436934489107970670.png",
        //   directory: "DE",
        // },
        {
          id: 2,
          text: "中國·香港",
          icon: "https://upload.vwingist.com/melscn/0image/2024/12/5436934489107970670.png",
          directory: "zh",
        },
        {
          id: 3,
          text: "English",
          icon: "https://upload.vwingist.com/melscn/0image/2024/12/5017170985069142864.png",
          directory: "en",
        },
        // {
        //   id: 4,
        //   countryname: "Россия",
        //   icon: "https://upload.vwingist.com/melscn/0image/2024/12/5011268359115285813.png",
        //   directory: "RU",
        // },
      ],
    };
  },
  computed: {
    ...mapState(["COUNTRY"]),
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    // 默认选中id=2的国家
    const defaultCountry = this.countries.find((country) => country.id === 2);
    this.$store.dispatch("updateCountry", defaultCountry);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 页面滚动时，关闭所有子菜单
      this.navItems.forEach((item) => {
        item.isToggle = false;
      });
      this.isShowMenu = false;

      this.isScrolled = window.scrollY > 0;
    },

    // 跳转到首页
    goHome() {
      this.$router.push("/Home");
    },

    handleMenu(item) {
      this.isShowMenu = false;
      if (item.link) {
        if (item.catalogType) {
          this.$router.push({
            path: "/ProductCatalog",
            query: {
              catalogType: item.catalogType,
            },
          });
        } else {
          this.$router.push(item.link);
        }
      }

      // this.isShowMenu = false;
      // if(item.link) {
      //   this.$router.push(item.link)
      // }
    },
    handleMenuItem(item) {
      this.isShowMenu = false;
      if (item.link) {
        this.$router.push(item.link);
      }
    },

    handleMouseEnter(item) {
      if (item.classify) {
        this.activeNavItem = item;
        this.isShowMenu = true;
        this.$nextTick(() => {
          // 这里可以放一些在 DOM 更新后执行的操作
        });
      } else {
        this.isShowMenu = false;
        this.activeNavItem = "";
        this.$nextTick(() => {
          // 这里可以放一些在 DOM 更新后执行的操作
        });
      }
    },

    handleMouseLeave() {
      this.isShowMenu = false;
    },

    handleDropdown(e) {
      this.$store.dispatch("updateCountry", e);
      // 更新 Vuex store 中的语言状态
      this.$store.dispatch("updateLanguage", e.directory);
      // 更新 VueI18n 实例的语言
      this.$i18n.locale = e.directory ? e.directory : "zh";
    },
  },
};
</script>
  
  <style scoped  lang="less">
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  z-index: 1000001;
  transition: background-color 0.1s ease;
  background-color: transparent; /* 默认透明 */
  &.scrolled {
    background-color: white; /* 滚动后变为白色 */
  }
  .nav-container {
    flex: 1;
    padding: 0 121px 0 177px;
    box-sizing: border-box;
    position: relative;
    height: 100%;
    z-index: 10000000001;
    .nav-left {
      width: 1184px;
      flex-shrink: 0;
      .menu-wrap {
        .menu-item {
          position: relative;
          z-index: 10000;
          .tab_logo {
            background-image: url("../assets/images/logo.png");
            width: 163px;
            height: 33px;
            background-size: cover;
            cursor: pointer;
          }
          .menu-item-text {
            font-size: 18px;
            color: #606060;
            cursor: pointer;
            position: relative;
            &:hover {
              color: #333333;
              &::after {
                display: inline-block;
                content: "";
                position: absolute;
                bottom: -10px;
                left: 0;
                right: 0;
                width: 90%;
                background: #333333;
                height: 2px;
                border-radius: 20px;
                left: 50%;
                transform: translateX(-50%);
              }
            }
          }
          .icon-xiangxiajiantou {
            font-size: 30px;
            color: #333333;
            // transform: rotate(180deg);
            &.active {
              transform: rotate(-180deg);
            }
          }
        }
        .menu-more {
          padding: 50px 40px;
          box-sizing: border-box;
          font-size: 24px;
          p {
            margin-bottom: 22px;
          }
        }
      }
    }
    .lang-join-wrap {
      .lang {
        font-size: 18px;
        color: #606060;
        cursor: pointer;
        margin-right: 15px;
        .icon-diqiu {
          font-size: 20px;
          margin-left: 5px;
        }
      }
      .country-select {
        position: relative;
        display: inline-block;
        font-size: 16px;
        z-index: 10000001;
        .selected-country {
          height: 30px;
          cursor: pointer;
          box-sizing: border-box;
          .content {
            .icon-diqiu {
              margin-right: 8px;
            }
            .flag {
              margin-right: 7px;
            }
          }
          .arr {
            .iconfont {
              font-size: 10px;
            }
            margin-left: 10px;
          }
        }
      }
    }
  }
  .menu-child-toggle {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    padding-top: 100px;
    background: #fff;
    font-size: 18px;
    color: #606060;
    box-sizing: border-box;
    align-items: flex-end;
    width: 100%;
    z-index: 10001;
    /* 确保内容在动画过程中不会溢出 */
    overflow: hidden;
    /* 新增过渡属性 */
    transition: all 0.3s ease;
    transform-origin: top;
    .menu-child-toggle-container {
      background: #f5f5f5;
      padding: 0 358px;
      align-items: flex-start;
      .menu-child-main {
        flex: 1;
        height: 100%;
        align-items: flex-start;
        box-sizing: border-box;
        color: #606060;
        padding-top: 60px;
        .menu-child-text {
          font-size: 18px;
          margin-right: 95px;
          cursor: pointer;
        }
        .menu-child-list {
          flex: 1;
          align-items: flex-start;
          .menu-child-item {
            margin-bottom: 50px;
            margin-right: 20px;
            &.flex-rowl {
              align-items: flex-start;
              p {
                width: 164px;
                flex-shrink: 0;
              }
            }
            p {
              font-size: 20px;
              margin-bottom: 53px;
              // white-space: nowrap;
              cursor: pointer;
            }
            ul {
              font-size: 18px;
              li {
                margin-bottom: 30px;
                cursor: pointer;
                line-height: 25px;
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
            &:last-child {
              margin-bottom: 0;
              margin-right: 0;
            }
          }
        }
      }
      .img {
        width: 360px;
        height: 347px;
        flex-shrink: 0;
        margin-left: 33px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  /* 过渡动画 */
  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.3s ease;
  }

  .slide-enter,
  .slide-leave-to {
    transform: scaleY(0);
    opacity: 0;
  }
}
</style>
  